module.exports = __webpack_public_path__ + "static/img/product4.331a38e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product4.jpg
// module id = hZ5B
// module chunks = 1